import i18n from 'helpers/i18n';

const PATH = 'fe.components.learning_resources.empty_state';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'No resources found'
  },
  description: {
    key: `${PATH}.description`,
    defaultValue:
      "We couldn't find any resources matching your current filters or search terms."
  }
};

function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <svg
        className="w-16 h-16 text-gray-400 mb-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        />
      </svg>
      <h3 className="text-lg font-semibold text-gray-700 mb-2">
        {i18n.ft(messages.title)}
      </h3>
      <p className="text-sm text-gray-500 max-w-md">
        {i18n.ft(messages.description)}
      </p>
    </div>
  );
}

export default EmptyState;
